import './App.css';

/**
 * Renders the step counter component at the bottom of the app.
 * 
 * @param {Object} props - The properties passed to the component.
 * @param {number} props.currentStep - The current active step (1-4).
 * @param {Object} props.stepStatus - An object containing the status of each step.
 * @param {string} props.stepStatus.step-1-status - The status of step 1.
 * @param {string} props.stepStatus.step-2-status - The status of step 2.
 * @param {string} props.stepStatus.step-3-status - The status of step 3.
 * @param {string} props.stepStatus.step-4-status - The status of step 4.
 * @returns {JSX.Element} A React component displaying the step counter.
 */
function StepCounter(props) {
  let stepOneStatus;
  let stepTwoStatus;
  let stepThreeStatus;
  let stepFourStatus;

  // Map through step status object and set corresponding step status
  let stepStatus = Object.entries(props.stepStatus).map(([key, value]) => {
    if(key == 'step-1-status'){
      stepOneStatus = value;
    }
    if(key == 'step-2-status'){
      stepTwoStatus = value;
    }
    if(key == 'step-3-status'){
      stepThreeStatus = value;
    }
    if(key == 'step-4-status'){
      stepFourStatus = value;
    }
  })

  return (
    <>
      <span className='step-top-border'></span>
      <div className='step-counter-wrapper'>
        <div className='step-counter flex flex-row'>
          {props.jobTitle != 'lab-tech' && <div className={props.currentStep >= 1 ? 'step flex active': 'step flex'}>
              <span className={`step-number ${stepOneStatus}`}><span>1</span></span>
              <p className='content'>College<br/>Credits</p>
          </div>}
          <div className={props.currentStep >= 2 ? 'step flex active': 'step flex'}>
          <span className={`step-number ${stepTwoStatus}`}><span>{props.jobTitle != 'lab-tech' ? "2" : "1" }</span></span>
              <p className='content'>{props.jobTitle == 'teacher' || props.jobTitle == 'adult-education-teacher' ? "Teaching" : "Working" }<br/>Experience</p>
          </div>
          <div className={props.currentStep >= 3 ? 'step flex active': 'step flex'}>
          <span className={`step-number ${stepThreeStatus}`}><span>{props.jobTitle != 'lab-tech' ? "3" : "2" }</span></span>
              <p className='content'>Length of<br/>Employment</p>
          </div>
          <div className={props.currentStep == 4 ? 'step final-step flex active': 'step final-step flex'}>
          <span className={`step-number ${stepFourStatus}`}><span>{props.jobTitle != 'lab-tech' ? "4" : "3" }</span></span>
              <p className='content'>Final<br/>Review</p>
          </div>
        </div>
      </div>
    </>
  );
}

export default StepCounter;